<template>
    <div class="d-content">
        <keep-alive>
            <div class="main-container">
                <h3 class="reportHeading">Select the Report Type:</h3>
                <div class="twoColumnGridDashboard marginbottom-5px">
                    <div class="ReportContainer" v-for="(nav, index) in navList" :key="index" @click="navigatePopup(nav)">
                        <div class="reportIcon">
                            <img :src="nav.imgUrl" alt="">
                        </div>
                        <div class="reportTitle">
                            <h3>{{nav.name }}</h3>
                            <p>{{nav.textContent}}</p>
                        </div>
                        <div class="reportArrow">
                            <img src="@/assets/arrowReport.svg" alt="">
                        </div>
                    </div>

                    <div  v-if="showModal">
                        <div class="reportmodal reportcustom-modal">
                            <div class="reportmodal-content reportmodal-sm reportmodal-border-radius">
                                <div class="reportmodal-header">
                                    <div class="row ">
                                        <h3>{{ modalHeader }}</h3>
                                    </div>
                                    <div>
                                        <img src="@/assets/close.png" class="close-img" v-on:click="showModal = false" alt="" />
                                    </div>
                                </div>
                                <div class="reportmodal-body">
                                    <table class="reportTable">
                                        <thead v-if="modalHeader == 'Payroll'" >
                                            <tr>
                                                <th>Sub Report Type</th>
                                                <th>Year</th>
                                                <th>Month</th>
                                                <th>To month</th>
                                                <th>Download</th>

                                            </tr>
                                        </thead>
                                        <thead v-else >
                                            <tr>
                                                <th>Sub Report Type</th>
                                                <th>Year</th>
                                                <th>Month</th>
                                                <th></th>
                                                <th>Download</th>

                                            </tr>
                                        </thead>
                
                                        <tbody>
                                            <tr v-for="(item, index) in subReportList" :key="index"> 
                                            <td>{{item.name}}</td>
                                            <td>
                                                <tl-select
                                                class="yearSelect"
                                                labelText="name"
                                                :options="financialYearList"
                                                v-model="item.financialYear"
                                                @change="(val)=>{item.financialYear=val; getFinancialYearMonths(item.financialYear);}"
                                            ></tl-select>
                                            </td>
                                            <td>
                                                <tl-select
                                                class="yearSelect"
                                                labelText="name"
                                                v-if="!['NPS Report', 'ITDeclaration Report', 'ITProof Approval Report'].includes(item.name)"
                                                :options="item.name == 'ETDS Report' ? etdsOptions : monthOptions"
                                                v-model="item.month"
                                                @change="(val)=>{item.month=val; updateFinancialYear(val, item);}"
                                            ></tl-select>
                                            </td>
                                            <td>
                                                <tl-select
                                                v-if="item.name == 'Cumulative Salary Register'"
                                                class="yearSelect"
                                                labelText="name"
                                                :options="monthOptions"
                                                v-model="item.toMonth"
                                                @change="(val)=>{item.toMonth=val; updateFinancialYear(val, item);}"
                                            ></tl-select>
                                            </td>
                                            
                                            <td>
                                                <div style="display: flex; gap: 10px;">
                                                    <div v-if="item.status" style="width: 130px;">
                                                        <tl-checkbox label="All Employees" @change="(bool) => locklist(bool, item)"></tl-checkbox>
                                                    </div>
                                                    <div class="table-download" @click="downloadReport(item)">
                                                        <img src="@/assets/reportExcel.svg" alt="">
                                                        <!-- <p>Download</p> -->
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <loading-animation v-show="showLoader"></loading-animation>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </keep-alive>
    </div>
</template>
<script>

import { monthOptionsObj } from "../../../../../apis/constants.js";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            showModal: false,
            modalHeader: "",
            subReportList: [],
            monthList: [],
            navList: [
                {
                    name: "Payroll",
                    imgUrl: require('@/assets/payrollReport.svg'),
                    textContent: "In simple terms, payroll can be defined as the process of paying a company’s employees."
                },
                {
                    name: "Income Tax",
                    imgUrl: require('@/assets/itReport.svg'),
                    textContent:"The individual income tax (or personal income tax) is a tax levied on the wages, salaries, dividends, interest, and other income."
                },
                {
                    name: "Statutory",
                    imgUrl: require('@/assets/statuatoryReport.svg'),
                    textContent:"If something is legal, it is allowed by the law, whereas if it is statutory, it is regulated by law."
                },
                // {
                //     name: "Employee Exit Reports",
                //     imgUrl: require('@/assets/exitReport.svg'),
                //     textContent:"The individual income tax (or personal income tax) is a tax levied on the wages, salaries, dividends, interest, and other income."
                // },
                // {
                //     name: "Salary",
                //     imgUrl: require('@/assets/salaryReport.svg'),
                //     textContent:" Salary is a fixed amount of money or compensation paid to an employee by an employer in return for work performed."
                // },
                {
                    name: "Others",
                    imgUrl: require('@/assets/otherReport.svg'),
                    textContent:"Click here to download other reports."
                },
            ],
            payrollList: [
                {name:"Consolidated Salary Register", financialYear: "", month: ""},
                {name:"Cumulative Salary Register", financialYear: "", month: ""},
                {name:"Pay Register(standard)", financialYear: "", month: "", status: "active"},
                {name:"Pay Register(with out standard)", financialYear: "", month: "", status: "active"}, 
                {name:"Variance", financialYear: "", month: "", status: "active"}, 
                {name:"Salary Variance", financialYear: "", month: "", status: "active"},
                { name: "Master CTC Report", financialYear: "", month: "", status: "active" },
                // {name:"Active Employees", financialYear: "", month: ""},
                // {name:"CTC Report",financialYear: "", month: ""},
                // {name:"Cost Center Wise Report",financialYear: "", month: ""},
                // {name:"Negative Salary", financialYear: "", month: ""},
                // {name:"Master CTC Report", financialYear: "", month: ""},
                // {name:"FFS Salary Register", financialYear: "", month: ""},
                // {name:"Employee Master Columns", financialYear:"",month:""},
                // {name:"Master Salary Report", financialYear: "", month: ""},
                // {name:"FNF Report", financialYear: "", month: ""},
                // {name:"Salary On Hold", financialYear: "", month: ""},
                // {name:"Zero Salary Report", financialYear: "", month: ""}, 
                // {name:"Employee Master", financialYear: "", month: ""},
                // {name:"Pending FNF Report", financialYear: "", month: ""},
                // {name:"PAN Not Available", financialYear: "", month: ""},
                // {name:"Head Count", financialYear: "", month: ""},
                // {name:"One Time Payment", financialYear: "", month: ""},
            ],
            itList: [
                // {name:"IT Reconciliation", financialYear: "", month: ""},
                // {name:"IT Reconciliation Detail Report",financialYear:"",month:""}, 
                // {name:"Income Tax Report", financialYear: "", month: ""}, 
                // {name:"Income Tax Compuation Statement", financialYear: "", month: ""},
                {name:"TDS Report", financialYear: "", month: "", status: "active"}, 
                {name:"ETDS Report", financialYear: "", month: "", status: "active"}, 
                {name:"ITDeclaration Report", financialYear: "", month: "", status: "active"}, 
                {name:"ITProof Approval Report", financialYear: "", month: "", status: "active"}, 
                // {name:"YTD TDS Report", financialYear: "", month: ""}
            ],
            statuatoryList: [
                {name:"PF Details Report", financialYear: "", month: "", status: "active"},
                {name:"PF Report", financialYear: "", month: "", status: "active"}, 
                {name:"ESI Report V2.0", financialYear: "", month: "", status: "active"},
                {name:"LWF Report-V1", financialYear: "", month: "", status: "active"}, 
                {name:"PT", financialYear: "", month: "", status: "active"},
            ],
            // exitList: [
            //     {name:"Absconding", financialYear: "", month: ""}, 
            //     {name:"Death", financialYear: "", month: ""}, 
            //     {name:"Termination", financialYear: "", month: ""}, 
            //     {name:"Resigned", financialYear: "", month: ""}, 
            //     {name:"Retirement", financialYear: "", month: ""}
            // ],
            // salaryList: [
            //     {name:"Annual Salary Report", financialYear: "", month: ""}
            // ],
            otherList: [
                // {name:"Bank Advice", financialYear: "", month: ""}, 
                // {name:"Bank Transfer", financialYear: "", month: ""},
                // {name:"Cost Center Report", financialYear: "", month: ""}, 
                // {name:"Bank Summary", financialYear: "", month: ""}, 
                // {name:"Payroll Summary", financialYear: "", month: ""}, 
                {name:"Bank Advice-Consolidated", financialYear:"", month:"", status: "active"}, 
                {name:"Bank_Advice_1.1_with_IFSC_Bank wise", financialYear:"", month:"", status: "active"},
                {name:"Employee Master",financialYear:"", month:"", status: "active"},
                {name:"Override Report",financialYear:"",month:"",status:"active"},
                {name:"NPS Report", financialYear:""},
                {name:"Bank Report",financialYear:"",month:""},
                {name:"Bulk Reports", financialYear:"", month:"", status: "active"}
            ],
            financialYearList: [],
            monthOptions: [],
            etdsOptions:["Quarter 1","Quarter 2","Quarter 3" ],
            monthsList: monthOptionsObj.monthListForFinancialYear,
            monthArray: monthOptionsObj.onlyMonths,
            showLoader: false,
        };
    },
    mounted() {
        this.getOrgLeIdList();
        //this.reportDataTransfer();
    },

    activated() {
        this.getOrgLeIdList();
        this.generateFinancialYear();
        this.reportDataTransfer();
        this.fetchPayGroupData();
    },

    computed: {
        ...mapGetters({
            getleid: "onboard/legal_entities/legal_entity_ID"
        }),

        le_id() {
            if (this.$route.params.entity_index)
                return this.getleid(this.$route.params.entity_index);
            else return this.getleid(0);
        },
    },

    methods: {

        ...mapActions({
            getOrgLeList: "onboard/organization/getOrgLeIdList",
            fetchPayGroupData: "dashboard/payroll/monthlypayroll/payGroup/fetchAll",
            act_download_esi_report: "dashboard/payroll/stdReports/downloadEsiReport",
            act_download_month_variance: "dashboard/payroll/newReports/downloadMonthVarianceReport",
            act_download_active_employees: "dashboard/payroll/newReports/downloadActiveEmployeeReport",
            act_download_negative_salary: "dashboard/payroll/newReports/downloadNegativeSalaryReport",
            act_download_zero_salary: "dashboard/payroll/newReports/downloadZeroSalaryReport",
            act_download_employee_master: "dashboard/payroll/newReports/downloadEmployeeMasterReport",
            act_download_pan_not_available: "dashboard/payroll/newReports/downloadPanNotAvailableReport",
            act_download_it_reconciliation: "dashboard/payroll/newReports/downloadItReconciliationReport",
            act_download_income_tax: "dashboard/payroll/newReports/downloadIncomeTaxReport",
            act_download_tds_report: "dashboard/payroll/newReports/downloadTDSReport",
            act_download_etds_report: "dashboard/payroll/newReports/downloadETDSReport",
            act_download_ytd_tds_report: "dashboard/payroll/newReports/downloadYtdTdsReport",
            act_download_ctc_report: "dashboard/payroll/newReports/downloadCTCreports",
            act_download_fnf_report: "dashboard/payroll/newReports/downloadFNFreports",
            act_download_salary_on_hold: "dashboard/payroll/newReports/downloadsalaryOnHoldreports",
            act_download_salary_variance:"dashboard/payroll/newReports/downloadsalaryVariance",
            act_download_cost_center_report: "dashboard/payroll/newReports/downloadCostCenterReport",
            act_download_pt_report: "dashboard/payroll/newReports/downloadPTReport",
            act_download_lwf_report: "dashboard/payroll/newReports/downloadLWFreport",
            act_download_pf_report: "dashboard/payroll/newReports/downloadPFreport",
            act_download_detailed_pf_report: "dashboard/payroll/newReports/downloadPFDetailedreport",
            act_download_esi_v2_report: "dashboard/payroll/newReports/downloadESIv2report",
            act_download_lwf_v1_report:"dashboard/payroll/newReports/downloadLWFv1report",
            act_download_it_compuation_report:"dashboard/payroll/newReports/downloadITcompuationReport",
            act_download_salary_register_report:"dashboard/payroll/newReports/downloadSalaryRegisterReport",
            act_download_cost_center_wise_report:"dashboard/payroll/newReports/downloadCostCenterWiseReport",
            act_download_cumulative_salary_register_report:"dashboard/payroll/newReports/downloadCumulativeSalaryRegisterReport",
            act_download_head_count_report: "dashboard/payroll/newReports/downloadHeadCountReport",
            act_download_master_salary_report: "dashboard/payroll/newReports/downloadMasterSalaryReport",
            act_download_one_time_payment_report: "dashboard/payroll/newReports/downloadOneTimePaymentReport",
            act_download_employee_master_columns_report: "dashboard/payroll/newReports/downloadEmployeeMasterColumnsReport",
            act_download_fss_salary_Register_report:"dashboard/payroll/newReports/downloadFFSsalaryRegisterReport",
            act_download_master_CTC_report: "dashboard/payroll/newReports/downloadMasterCtcReport",
            act_download_pending_FNF_report: "dashboard/payroll/newReports/downloadPendingFNFreport",
            act_download_itreconciliation_detail_report: "dashboard/payroll/newReports/downloadItReconciliationDetailedReport",
            act_download_bank_advice_consolidated_report: "dashboard/payroll/newReports/downloadBankAdviceConsolidatedReport",
            act_download_bank_advice_with_IFSC_bank_wise_report: "dashboard/payroll/newReports/downloadBankAdviceWithIFSCBankWiseReport",
            act_download_report_data_transfer: "dashboard/payroll/newReports/reportDataTransfer",
            act_download_report_pay_register_standard: "dashboard/payroll/newReports/downloadPayRegisterWithStandardReport",
            act_download_report_pay_register_without_standard: "dashboard/payroll/newReports/downloadPayRegisterWithOutStandardReport",
            act_download_std_employee_master: "dashboard/payroll/newReports/downloadStdEmployeeMaster",
            act_download_override_report:"dashboard/payroll/newReports/downloadOverrideReport",
            act_download_nps_report:"dashboard/payroll/newReports/downloadNpsReport",
            act_download_freeze_std_report: "dashboard/payroll/newReports/downloadStdReports",
            act_download_it_declared_template: "dashboard/payroll/incometax/downloadItDeclaredDetails",
            act_download_it_proof_template:"dashboard/payroll/incometax/downloadItProofDetails",
            act_download_bank_report:"dashboard/payroll/newReports/downloadBankReport",
            act_download_bulk_reports:"dashboard/payroll/newReports/downloadBulkReports",
        }),

        locklist(val, item){
            if(val){
                item.status = "both"
            }else{
                item.status = "active"
            }
        },

        navigatePopup(value){
            switch (value.name) {
                case "Payroll":
                    this.modalHeader = "Payroll";
                    this.subReportList = this.payrollList;
                     for(let i in this.subReportList){
                         this.subReportList[i].toMonth =""
                     }
                    this.showModal = true;
                    break;
                case "Income Tax":
                    this.modalHeader = "Income Tax";
                    this.subReportList = this.itList;
                    this.showModal = true;
                    break;
                case "Statutory":
                    this.modalHeader = "Statutory";
                    this.subReportList = this.statuatoryList;
                    this.showModal = true;
                    break;
                case "Employee Exit Reports":
                    this.modalHeader = "Employee Exit Reports";
                    this.subReportList = this.exitList;
                    this.showModal = true;
                    break;
                case "Salary":
                    this.modalHeader = "Salary";
                    this.subReportList = this.salaryList;
                    this.showModal = true;
                    break;
                case "Others":
                    this.modalHeader = "Others";
                    this.subReportList = this.otherList;
                    this.showModal = true;
                    break;
                default:
                    break;
            }
        },

        /* function to generate financial year from previous 5 years */
        generateFinancialYear() {
            try {
                let date = new Date();
                let year =
                    date.getMonth() > 2 ? date.getFullYear() : date.getFullYear() - 1;
                for (let i = year; i > year - 5; i--) {
                    this.financialYearList.push({
                        name: i + "-" + (i + 1),
                        value: i + ""
                    });
                }
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },

        async reportDataTransfer(){
            try {
                let obj ={
                    le_id : this.le_id,
                }
                await this.act_download_report_data_transfer(obj);
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },

        updateFinancialYear(val, item) {
            if (val.index < 3) {
                item.financialYear.value = item.financialYear.name.split("-")[1];
            } else {
                item.financialYear.value = item.financialYear.name.split("-")[0];
            }
        },

        /* function to get months of a financial year based on selected financial year */
        getFinancialYearMonths(financialYear) {
            try {
                let date = new Date();
                if (
                    date.getMonth() > 2 &&
                    financialYear.value == date.getFullYear()
                ) {
                    let index = this.monthsList.findIndex(
                        item => item.name == this.monthArray[date.getMonth()]
                    );
                    this.monthOptions = this.monthsList.slice(0, index + 1);
                } else if (financialYear.value < date.getFullYear() - 1) {
                    this.monthOptions = this.monthsList;
                } else if (financialYear.value == date.getFullYear() - 1) {
                    if (date.getMonth() < 3) {
                        let index = this.monthsList.findIndex(
                            item => item.name == this.monthArray[date.getMonth()]
                        );
                        this.monthOptions = this.monthsList.slice(0, index + 1);
                    } else {
                        this.monthOptions = this.monthsList;
                    }
                }
            } catch (error) {
                this.toast = true;
                this.errmsg = error;
            }
        },

        async downloadReport(subReport){
            switch (subReport.name) {
                case "PF Details Report":
                    this.getPfDetailledReport(subReport);
                    break;
                case "PF Report":
                    this.getPfReport(subReport);
                    break;
                case "ESI":
                    this.getEsiReport(subReport);
                    break;
                case "ESI Report V2.0":
                    this.getEsiReportV2(subReport);
                    break;
                case "PT":
                    this.getPtReport(subReport);
                    break;
                case "LWF":
                    this.getLwfReport(subReport);
                    break;
                case "Variance":
                    this.getVarianceReport(subReport);
                    break;
                case "Active Employees":
                    this.getActiveEmployeeReport(subReport);
                    break;
                case "Negative Salary":
                    this.getNegativeSalaryReport(subReport);
                    break;
                case "Zero Salary Report":
                    this.getZeroSalaryReport(subReport);
                    break;
                case "Employee Master":
                    this.getEmployeeMasterReport(subReport);
                    break;
                case "Override Report":
                    this.getOverrideReport(subReport);
                    break;    
                case "NPS Report":
                    this.getNPSReport(subReport);
                    break; 
                case "PAN Not Available":
                    this.getPanNotAvailableReport(subReport);
                    break;
                case "IT Reconciliation":
                    this.getItRecociliationReport(subReport);
                    break;
                case "Income Tax Report":
                    this.getIncomeTaxReport(subReport);
                    break;
                case "TDS Report":
                    this.getTDSReport(subReport);
                    break;
                case "ETDS Report":
                    this.getETDSReport(subReport);
                    break;
                case "YTD TDS Report":
                    this.getYtdTdsReport(subReport);
                    break;
                case "CTC Report":
                    this.getCtcReport(subReport)
                    break;
                case "FNF Report":
                    this.getFnfReport(subReport)
                    break;
                case "Salary On Hold":
                    this.getSalaryOnHoldReport(subReport)
                    break;
                case "Salary Variance":
                    this.getSalaryVariance(subReport)
                    break;
                case "Cost Center Report":
                    this.getCostCenterReport(subReport)
                    break;
                case "LWF Report-V1":
                    this.getLWFv1Report(subReport)
                    break;
                case "Income Tax Compuation Statement":
                    this.getIncomeTaxCompuationStatement(subReport)
                    break; 
                case "Consolidated Salary Register":
                    this.getSalaryRegister(subReport)
                    break;
                case "Cost Center Wise Report":
                    this.getCostCenterWiseReport(subReport)
                     break;
                case "Cumulative Salary Register":
                    this.getCumulativeSalaryRigister(subReport)
                    break;
                case "Head Count":
                    this.getHeadCount(subReport)
                    break;
                case "Master Salary Report":
                    this.getMasterSalaryReport(subReport)
                    break;
                case "One Time Payment": 
                    this.getOneTimePaymentReport(subReport)
                    break;
                case "Pay Register(standard)":
                    this.getPayRegisterStandardReport(subReport)
                    break;
                case "Pay Register(with out standard)": 
                    this.getPayRegisterWithOutStandardReport(subReport)
                    break;
                case "Employee Master Columns":
                    this.getEmployeeMasterColumnsReport(subReport)
                    break;
                case "FFS Salary Register" :
                    this.getFFSsalaryRegister(subReport)
                    break;
                case "Master CTC Report" :
                    this.getMasterCTCReport(subReport)
                    break;
                case "Pending FNF Report" :
                    this.getPendingFNFreport(subReport)
                    break;
                case "IT Reconciliation Detail Report":
                    this.getITReconciliationDetailReport(subReport)
                    break;
                case "Bank Advice-Consolidated":
                    this.getBankAdviceConsolidatedReport(subReport)
                    break;
                case "Bank_Advice_1.1_with_IFSC_Bank wise":
                    this.getBank_Advice_with_IFSC_Bank_wise_Report(subReport)
                    break;
                case "ITDeclaration Report":
                    this.getITDeclaration_report(subReport)
                    break;
                case "ITProof Approval Report":
                    this.getITProof_approval_report(subReport)
                    break;
                case "Bank Report":
                    this.getBankReport(subReport);
                    break;
                case "Bulk Reports":
                    this.getBulkReports(subReport);
                    break;   
                default:
                    break;
            }
        },
       
        //Download Bank Advice-Consolidated Report
        async getBankAdviceConsolidatedReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    let res = await this.act_download_bank_advice_consolidated_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Bank_Advice_1.1_with_IFSC_Bank wise Report
        async getBank_Advice_with_IFSC_Bank_wise_Report(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_bank_advice_with_IFSC_bank_wise_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        async getITDeclaration_report(element) {
            try {
                if (element.financialYear) {
                    this.showLoader = true;
                    let payload = {
                        le_id: this.le_id,
                        financial_year: element.financialYear.value
                    }
                    await this.act_download_it_declared_template(payload);
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        async getITProof_approval_report(element) {
            try {
                if (element.financialYear) {
                    this.showLoader = true;
                    let payload = {
                        le_id: this.le_id,
                        financial_year: element.financialYear.value
                    }
                    await this.act_download_it_proof_template(payload);
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        //Download PF Detailed Report
        async getPfDetailledReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_detailed_pf_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download PF Report
        async getPfReport(element){
            try {
                if (element.financialYear && element.month) {
                    this.showLoader = true;
                    let stdObj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financial_year: element.financialYear.value,
                        type: 'pf'
                    }
                    let stdRes = await this.act_download_freeze_std_report(stdObj)
                    if(stdRes && stdRes.data && stdRes.data.payload) {
                    } else {
                        let obj = {
                            le_id: this.le_id,
                            month: element.month.value,
                            year: element.financialYear.value,
                            status: element.status
                        }
                        await this.act_download_pf_report(obj);
                    }
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        // Download ITReconciliationDetailReport
        async getITReconciliationDetailReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_itreconciliation_detail_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download pending FNF Report
        async getPendingFNFreport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_pending_FNF_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Master CTC  Report
        async getMasterCTCReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_master_CTC_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //DownloadFFSsalaryRegisterReport
        async getFFSsalaryRegister(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_fss_salary_Register_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Employee Master Columns Report
        async getEmployeeMasterColumnsReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_employee_master_columns_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        // download MASTER salaryReport
        async getMasterSalaryReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_master_salary_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        // download One Tine Payment Report
        async getOneTimePaymentReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_one_time_payment_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }   
        },

        // download pay register with standard Report
        async getPayRegisterStandardReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_report_pay_register_standard(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }   
        },
            
        // download pay register with out standard Report
        async getPayRegisterWithOutStandardReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_report_pay_register_without_standard(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }   
        },

        //Download cumulative Salary Rigister Report
        async getCumulativeSalaryRigister(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        from_month: element.month.value,
                        to_month:element.toMonth.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_cumulative_salary_register_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download ESI Report
        async getEsiReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_esi_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        
        //Download ESI V2.0 Report
        async getEsiReportV2(element){
            try {
                if (element.financialYear && element.month) {
                    this.showLoader = true;
                    let stdObj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financial_year: element.financialYear.value,
                        type: 'esi'
                    }
                    let stdRes = await this.act_download_freeze_std_report(stdObj)
                    if(stdRes && stdRes.data && stdRes.data.payload) {
                    } else {
                        let obj = {
                            le_id: this.le_id,
                            month: element.month.value,
                            year: element.financialYear.value,
                            status: element.status
                        }
                        await this.act_download_esi_v2_report(obj);
                    }
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Head count Report
        async getHeadCount(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financial_year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_head_count_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download PT Report
        async getPtReport(element){
            try {
                if (element.financialYear && element.month) {
                    this.showLoader = true;
                    let stdObj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financial_year: element.financialYear.value,
                        type: 'pt'
                    }
                    let stdRes = await this.act_download_freeze_std_report(stdObj)
                    console.log("stdRes>>>>>>>>>>>>>>>>>>>>>>>.", stdRes.data)
                    if(stdRes && stdRes.data && stdRes.data.payload) {
                    } else {
                        let obj = {
                            le_id: this.le_id,
                            month: element.month.value,
                            year: element.financialYear.value,
                            status: element.status
                        }
                        await this.act_download_pt_report(obj);
                    }
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download LWF Report
        async getLwfReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_lwf_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
       
        //Download LWF v1 Report
        async getLWFv1Report(element){
            try {
                if (element.financialYear && element.month) {
                    this.showLoader = true;
                    let stdObj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financial_year: element.financialYear.value,
                        type: 'lwf'
                    }
                    let stdRes = await this.act_download_freeze_std_report(stdObj)
                    if(stdRes && stdRes.data && stdRes.data.payload) {
                    } else {
                        let obj = {
                            le_id: this.le_id,
                            month: element.month.value,
                            year: element.financialYear.value,
                            status: element.status
                        }
                        await this.act_download_lwf_v1_report(obj);
                    }
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download current month last month variance
        async getVarianceReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_month_variance(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Active Employees List
        async getActiveEmployeeReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_active_employees(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Negative Salary Report
        async getNegativeSalaryReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_negative_salary(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        
        //Download Zero salary Report
        async getZeroSalaryReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_zero_salary(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Employee Master Report
        async getEmployeeMasterReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        // month: element.month.value,
                        year: element.financialYear.value,
                        month: element.month.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_std_employee_master(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Employee Master Report
        async getOverrideReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        // month: element.month.value,
                        year: element.financialYear.value,
                        month: element.month.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_override_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        async getNPSReport(element){
            try {
                if (element.financialYear) {
                    let obj = {
                        le_id: this.le_id,
                        financial_year: element.financialYear.value,
                    }
                    this.showLoader = true;
                    await this.act_download_nps_report(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },
        //Download PAN not available report
        async getPanNotAvailableReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_pan_not_available(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Downlaod IT Reconciliation report
        async getItRecociliationReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_it_reconciliation(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download Income Tax Report
        async getIncomeTaxReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_income_tax(
                        obj
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        //Download TDS report
        async getTDSReport(element){
            try {
                if (element.financialYear && element.month) {
                    this.showLoader = true;
                    let stdObj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financial_year: element.financialYear.value,
                        type: 'tds'
                    }
                    let stdRes = await this.act_download_freeze_std_report(stdObj)
                    if(stdRes && stdRes.data && stdRes.data.payload) {
                    } else {
                        let obj = {
                            le_id: this.le_id,
                            month: element.month.value,
                            year: element.financialYear.value,
                            status: element.status
                        }
                        await this.act_download_tds_report(obj);
                    }
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getETDSReport(element){
            try {
                console.log(element, "Hello")
                if (element.financialYear && element.month) {
                    let { month, quarter } = element.month === 'Quarter 1' ? { month: 'jun', quarter: 'Q1' } :
                           element.month === 'Quarter 2' ? { month: 'sep', quarter: 'Q2' } :
                           element.month === 'Quarter 3' ? { month: 'dec', quarter: 'Q3' } :
                           {};
                    let obj = {
                        le_id: this.le_id,
                        month: month,
                        year: element.financialYear.value,
                        status: element.status,
                        quarter:quarter
                    }
                    console.log(obj, "Objsect");
                    this.showLoader = true;
                    await this.act_download_etds_report(
                        obj 
                    );
                    console.log(res, "Respoense");
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getYtdTdsReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_ytd_tds_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getCtcReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_ctc_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getFnfReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_fnf_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getSalaryOnHoldReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_salary_on_hold(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getSalaryVariance(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.value,
                        status: element.status
                    }
                    this.showLoader = true;
                    await this.act_download_salary_variance(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getCostCenterReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_cost_center_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        // Income Tax Compuation Statement
        async getIncomeTaxCompuationStatement(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_it_compuation_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getSalaryRegister(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        financialYear: element.financialYear.name
                    }
                    this.showLoader = true;
                    await this.act_download_salary_register_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getCostCenterWiseReport(element){
            try {
                if (element.financialYear && element.month) {
                    let obj = {
                        le_id: this.le_id,
                        month: element.month.value,
                        year: element.financialYear.value
                    }
                    this.showLoader = true;
                    await this.act_download_cost_center_wise_report(
                        obj 
                    );
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },

        async getOrgLeIdList() {
            // const org = this.orgId;
            // const le = this.le_id;
            //console.log("Org:", org);
            //console.log("Le ID", le);
            let bodyParams = {};
            let data = await this.getOrgLeList({
                data: {
                    ...bodyParams
                }
            });
            this.role = data.data.user.userRole;
            this.reportosValue = data.data.user.permissions.reportos ? true : false;
        },
        async getBankReport(element){
            try {
                if (element.financialYear && element.month) {
                     let obj = {
                        le_id: this.le_id,
                        financial_year: element.financialYear.value,
                        month: element.month.value
                    }
                    this.showLoader = true;
                    let res = await this.act_download_bank_report(
                        obj
                    );
                    if(res.status){

                    const { data, fileName } = res.data.payload[0];
                    if(!data||data.length===0){
                        this.showLoader = false;
                        this.toast = true;
                        this.errmsg = "No data found";
                        alert("No data found");
                        return;
                    }else{
                    const blob = new Blob([data], { type: "text/plain;charset=utf-8" });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                    this.showLoader = false;
                    this.toast = false;
                    }
                    } else {
                        this.showLoader = false;
                        this.toast = true;
                        this.errmsg = "Something went wrong";
                    }
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
            }
        },

        async getBulkReports(element){
            try {
                if (element.financialYear && element.month) {
                    // Get paygroup_id from store
                    const payGroupData = this.$store.getters['dashboard/payroll/monthlypayroll/payGroup/data'];
                    const paygroup_id = payGroupData && payGroupData.length > 0 ? payGroupData[0].id : null;
                    
                    let obj = {
                        le_id: this.le_id,
                        year: element.financialYear.value,
                        month: element.month.value,
                        status: element.status,
                        paygroup_id: paygroup_id
                    }
                    this.showLoader = true;
                    await this.act_download_bulk_reports(obj);
                    this.showLoader = false;
                    this.toast = false;
                } else {
                    this.toast = true;
                    this.errmsg = "Please select financial year and month";
                }
            } catch (error) {
                setTimeout(() => {
                    this.toast = true;
                    this.showLoader = false;
                    this.errmsg = error;
                }, 1000);
            }
        },    
    }
};
</script>
  
<style lang="scss" scoped>
.reportHeading {
        margin-bottom: 30px;
        color: #777777;
    }

    .ReportContainer {
        width: 100%;
        padding: 10px 20px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 8px;
        border: solid 1px #F0F0F0;
        background-color: #f5f5f5;
        cursor: pointer;
    }

    .reportTitle {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        margin-left: 20px;
        margin-right: 20px;
        // align-self: start;
    }

    .reportTitle>h3 {
        color: #34C0BD;
        margin-bottom: 5px;
    }

    .reportTitle>p {
        color: #777777;
        margin: 0;
    }

    .reportArrow > img{
        align-self: end;
    }


    .reportbutton {
        border: none;
        color: #FFF;
        background: #42b983;
        appearance: none;
        font: inherit;
        font-size: 1.8rem;
        padding: .5em 1em;
        border-radius: .3em;
        cursor: pointer;
    }

    .reportcustom-modal {
        &.reportmodal {
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            z-index: 6;
            left: 0px;
            top: 0px;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
        }
      .reportmodal-body {
        height: 80%;
        overflow-x: hidden;
        overflow-y: auto;
      }
    //   .reportmodal thead{
    //     overflow: visible;
    //   }
        /* Modal Content */
        .reportmodal-content {
            background-color: white;
            z-index: 2;
            border-radius: 8px;
            min-width: 78%;
            height: 75%;
            &.reportmodal-md {
                width: 760px;
            }

            &.reportmodal-sm {
                width: 488px;
            }

            .reportmodal-header {
                display: flex;
                align-items: center;
                height: 50px;
                padding: 20px;
                border-top-right-radius: 8px;
                border-top-left-radius: 8px;
                border: solid 1px #F0F0F0;
                background-color: #ffffff;

                h3 {
                    font-weight: 600;
                    color: #34C0BD;
                }
            }

            .modal-footer {
                padding: 15px;
                text-align: right;
                border-top: 1px solid #34C0BD;
            }
        }
    }

    .reportTable{
        border-collapse: collapse;
        font-size: 1rem;
        min-width: 100%;
    }

    .reportTable thead tr {
        background-color: #f5f5f5;
        height: 50px;
        text-align: left;
        border-bottom: 2px solid #34C0BD;
    }

    .reportTable th,
    .reportTable td {
        padding: 0 20px 8px;
    }

    .reportTable td:last-child{
        width: 25%;
    }

    .reportTable tbody tr {
        border-bottom: 0.5px solid #dddddd;
    }

    .reportTable tbody tr .yearSelect{
        min-width: 170px;
    }


    .reportTable tbody tr:last-child {
        border-bottom: none;
    }

    .table-download{
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .table-download p {
        margin: 0 0 0 10px;
    }

    // .checkboxShow{
    //     padding-left: -50px;
    //     display: block;
    // }

    // .checkboxHide{
    //     margin-left: -60px;
    //     visibility: hidden;
    // }
</style>
  